import { nothing, svg } from 'lit';
import { KeyScale } from '../../axis/key/KeyScale.js';
import { ValueScale } from '../../axis/value/ValueScale.js';
import { bounds, highlightStateProvider } from '../../types.js';
import { AreaRenderGroup, areaRenderGroupData } from '../area/types.js';
import { LineRenderGroup, lineRenderGroupData } from '../line/types.js';
import { vector } from '../../../common/types.js';
import { interpolate, svgTransition } from '../../../common/directives/svgTransition.js';
import { timing } from '../../animation.js';
import { seriesOpacityOnInactiveHighlight } from '../../style.js';
export const DataPoint = ({
  keyScale,
  valueScale,
  dp,
  group,
  boundary,
  animate,
  highlightStateProvider
}: {
  keyScale: KeyScale;
  valueScale: ValueScale;
  dp: lineRenderGroupData | areaRenderGroupData;
  group: LineRenderGroup | AreaRenderGroup;
  boundary: bounds;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) => {
  if (!Number.isFinite(dp.value)) {
    return nothing;
  }
  const point: vector = [keyScale.center(dp.key), valueScale.position(dp.value)];
  if (point[1] < boundary.top || point[1] > boundary.bottom) {
    return nothing;
  }
  const opacity = highlightStateProvider(group.name) === 'inactive' ? seriesOpacityOnInactiveHighlight : 1;
  return svg`<circle
    r="3"
    fill=${group.color}
    ${svgTransition({
    timing: timing(animate),
    attributes: {
      cx: interpolate.constant(point[0], cx => cx.toString()),
      cy: interpolate.constant(point[1], cy => cy.toString()),
      opacity: interpolate.standard(0, opacity, 0)
    }
  })}
  />`;
};